import { render, staticRenderFns } from "./KitInfo.vue?vue&type=template&id=c469f3a0"
import script from "./KitInfo.vue?vue&type=script&lang=js"
export * from "./KitInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports